import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import wysiwyg from 'vue-wysiwyg'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/quill-editor'
import '@/libs/vue-select'
import '@/libs/vue-ripple'
import '@/libs/dayjs'
import '@/libs/statusData'
import '@/libs/statusValue'
import '@/libs/categoryData'
import '@/libs/categoryValue'
import '@/libs/vee-validate'
import '@/libs/prototype'
import '@/libs/permission'
import '@/libs/wrap-word'
import '@/libs/replacePhoneNumber'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(wysiwyg, {})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
